import _objectSpread from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { format, startOfDay, endOfDay } from 'date-fns';
import config from '@/pathConfig';
import { batchUploadFile, queryOrganByUser } from '@/api/commonApi.js';
import { saveReimburse, queryTravel, submitReimburse } from '@/api/reimburse/reimburseApi.js';
export default {
  data: function data() {
    return {
      config: config,
      loading: false,
      options: [],
      // 级联选择数据
      userInfo: this.$hdk.userInfo.get(),
      cardTitle: '新建差旅费用报销单',
      labelCol: {
        span: 8
      },
      wrapperCol: {
        span: 16
      },
      otherFees: [{
        id: 1,
        name: '招待费'
      }, {
        id: 2,
        name: '场地费'
      }, {
        id: 3,
        name: '食宿费'
      }, {
        id: 4,
        name: '保险费'
      }, {
        id: 5,
        name: '其他费用'
      }],
      organPostId: [],
      formObject: {
        detail: {
          id: '',
          cateId: 1,
          typeId: '',
          organId: '',
          organPostId: [],
          postId: '',
          postName: '',
          applyDate: '',
          // 报销日期
          reason: '',
          // 出差事由
          totalAmount: '',
          // 总金额
          totalAmountBig: '',
          // 总金额（大写)
          advanceFee: '',
          // 预支旅费
          payeeUser: '',
          // 领款人
          attach: [],
          // 附件
          matterList: [{
            startdate: '',
            startplace: '',
            enddate: '',
            endplace: '',
            traffictool: '',
            trafficmoney: '',
            peoplenum: '',
            daynum: '',
            subsidystandard: '',
            subsidymoney: '',
            servefee: '',
            sitefee: '',
            roomboardfee: '',
            insurancefee: '',
            waterfee: '',
            mattertotal: ''
          }],
          trafficMoney: '',
          // 交通金额
          businessUser: '',
          // 出差人数
          evectionDay: '',
          // 出差天数
          evectionStandard: '',
          // 出差标准
          evectionMoney: '',
          // 出差金额
          entertainMoney: '',
          // 招待费
          fieldMoney: '',
          // 场地费
          foodMoney: '',
          // 食宿费
          insuranceMoney: '',
          // 保险费
          waterMoney: '',
          // 用水费
          mattertotalMoney: '' // 合计
        }
      },
      rules: {
        // organPostId: [{ required: true, message: '请选择所属组织及岗位' }],
        applyDate: [{
          required: true,
          message: '请选择报销日期'
        }],
        reason: [{
          required: true,
          message: '请输入出差事由'
        }, {
          max: 100,
          message: '字数超出限制100'
        }],
        advanceFee: [{
          required: true,
          message: '请输入预支旅费'
        }],
        payeeUser: [{
          required: true,
          message: '请输入领款人'
        }, {
          max: 50,
          message: '字数超出限制50'
        }]
      },
      fileObj: []
    };
  },
  created: function created() {
    var _this = this;
    var $route = this.$route,
      userInfo = this.userInfo;
    // 级联数据处理
    this.options = _.map(userInfo.organPostTree, function (item) {
      item.postList = _.map(item.postList, function (subItem) {
        return {
          label: subItem.postName,
          value: subItem.postId,
          children: null
        };
      });
      return {
        label: item.organName,
        value: item.organId,
        typeId: item.typeId,
        children: item.postList
      };
    });
    if ($route.query.type == 1) {
      this.cardTitle = '新建差旅费用报销单';
    } else if ($route.query.type == 2) {
      this.cardTitle = '编辑差旅费用报销单';
      queryTravel($route.query.fillId).then(function (res) {
        var cost = res.data;
        _this.formObject = cost;
        _this.organPostId = [cost.detail.organId, cost.detail.postId];
        _this.formObject.detail.organPostId = [cost.detail.organId, cost.detail.postId];
        _this.fileObj = _.map(cost.detail.attach, function (item) {
          return {
            fileid: item.id,
            filename: item.fileName,
            filepath: item.filePath,
            uid: item.id,
            name: item.fileName,
            status: 'done',
            type: 1
          };
        });
      });
    }
  },
  methods: {
    addMatter: function addMatter() {
      this.formObject.detail.matterList.push({
        startdate: '',
        startplace: '',
        enddate: '',
        endplace: '',
        traffictool: '',
        trafficmoney: '',
        peoplenum: '',
        daynum: '',
        subsidystandard: '',
        subsidymoney: '',
        servefee: '',
        sitefee: '',
        roomboardfee: '',
        insurancefee: '',
        waterfee: '',
        mattertotal: ''
      });
    },
    delMatter: function delMatter(item) {
      var totalMoneyChange = this.totalMoneyChange;
      var index = this.formObject.detail.matterList.indexOf(item);
      if (index !== -1) {
        this.formObject.detail.matterList.splice(index, 1);
      }
      // 调用自动计算接口
      totalMoneyChange(item);
    },
    saveDraft: function saveDraft() {
      var _this2 = this;
      var $refs = this.$refs,
        $set = this.$set,
        formObject = this.formObject,
        fileObj = this.fileObj,
        callSaveReimburseFill = this.callSaveReimburseFill;
      $refs.addForm.validate(function (valid) {
        if (valid) {
          // 上传附件
          if (fileObj.length > 0) {
            var newFileObj = _.map(fileObj, function (item) {
              if (item.type === 0) {
                return item;
              } else {
                return;
              }
            });
            // 去除为空的
            newFileObj = _.compact(newFileObj);
            _this2.formObject.detail.attach = _.remove(fileObj, function (n) {
              if (n.type === 1) {
                return n;
              }
            });

            // 判断处理后的附件是否为空,为空表示没有新上传附件
            if (newFileObj.length > 0) {
              batchUploadFile(newFileObj).then(function (res) {
                _.map(res.data.data, function (item) {
                  _this2.formObject.detail.attach.push({
                    filename: item.originalName,
                    filepath: item.filepath,
                    originalname: item.originalName
                  });
                });
                callSaveReimburseFill(1);
              });
            } else {
              callSaveReimburseFill(1);
            }
          } else {
            callSaveReimburseFill(1);
          }
        }
      });
    },
    /*
     * 调用存入草稿的接口
     */
    callSaveReimburseFill: function callSaveReimburseFill(flag) {
      var _this3 = this;
      var $set = this.$set,
        $message = this.$message,
        formObject = this.formObject,
        goBack = this.goBack,
        optionVal = this.optionVal;
      return new Promise(function (resolve, reject) {
        _this3.loading = true;
        if (!formObject.detail.id && formObject.detail.applyDate) {
          $set(formObject, 'applyDate', format(formObject.detail.applyDate._d, 'yyyy-MM-dd'));
        }
        saveReimburse(_objectSpread({}, formObject.detail)).then(function (res) {
          if (res.data.code == 200 && flag == 1) {
            $message.success('保存成功');
            goBack();
          } else if (res.data.code == 200 && flag == 0) {
            resolve(res.data.data);
          }
          _this3.loading = false;
        });
      });
    },
    submitReimburse: function submitReimburse() {
      var _this4 = this;
      var $refs = this.$refs,
        $confirm = this.$confirm,
        $message = this.$message,
        formObject = this.formObject,
        goBack = this.goBack,
        fileObj = this.fileObj,
        mySubmitReimburse = this.mySubmitReimburse;
      $refs.addForm.validate(function (valid) {
        if (valid) {
          _this4.loading = true;
          $confirm('确认提交吗?', '提示', {
            type: 'info',
            confirmButtonText: '确认',
            cancelButtonText: '取消'
          }).then(function () {
            // 上传附件
            if (fileObj.length > 0) {
              var newFileObj = _.map(fileObj, function (item) {
                if (item.type === 0) {
                  return item;
                } else {
                  return;
                }
              });
              // 去除为空的
              newFileObj = _.compact(newFileObj);
              _this4.formObject.detail.attach = _.remove(fileObj, function (n) {
                if (n.type === 1) {
                  return n;
                }
              });

              // 判断处理后的附件是否为空,为空表示没有新上传附件
              if (newFileObj.length > 0) {
                batchUploadFile(newFileObj).then(function (res) {
                  _.map(res.data.data, function (item) {
                    _this4.formObject.detail.attach.push({
                      filename: item.originalName,
                      filepath: item.filepath,
                      originalname: item.originalName
                    });
                  });
                  mySubmitReimburse();
                });
              } else {
                mySubmitReimburse();
              }
            } else {
              mySubmitReimburse();
            }
          }).catch(function () {
            _this4.loading = false;
          });
        }
      });
    },
    mySubmitReimburse: function mySubmitReimburse() {
      var _this5 = this;
      var $message = this.$message,
        formObject = this.formObject,
        callSaveReimburseFill = this.callSaveReimburseFill,
        goBack = this.goBack;
      if (formObject.detail.id) {
        callSaveReimburseFill(0).then(function (res) {
          submitReimburse(formObject.detail.id).then(function (res) {
            if (res.data.code == 200) {
              $message.success('提交成功');
              goBack();
            }
            _this5.loading = false;
          });
        });
      } else {
        callSaveReimburseFill(0).then(function (res) {
          _this5.formObject.detail.id = res; // 赋值存为草稿的主键id用于提交
          submitReimburse(_this5.formObject.detail.id).then(function (res) {
            if (res.data.code == 200) {
              $message.success('提交成功');
              goBack();
            }
            _this5.loading = false;
          });
        });
      }
    },
    // saveDraft() {
    //     const { $refs, $message, formObject, goBack } = this;
    //     $refs.addForm.validate(valid => {
    //         if (valid) {
    //             saveReimburse({...formObject.detail}).then(res => {
    //                $message.success('存为草稿成功');
    //                goBack();
    //             });
    //         }
    //     })
    // },
    // submitReimburse() {
    //     const { $refs, $confirm, $message, formObject, goBack } = this;
    //     $refs.addForm.validate(valid => {
    //         if (valid) {
    //             this.loading = true;
    //             $confirm('确认提交吗?', '提示', {
    //                 type: 'info',
    //                 confirmButtonText: '确认',
    //                 cancelButtonText: '取消'
    //             }).then(() => { 
    //                 $message.success('提交成功');
    //                 goBack();
    //             }).catch(() => {
    //                 this.loading = false;
    //             });
    //         }
    //     })
    // },
    /**
     * 文件上传存值
     */
    actionUpload: function actionUpload(data) {
      var $message = this.$message,
        fileObj = this.fileObj;
      if (fileObj.length > 5) {
        $message.error('文件最多同时上传5个');
        return;
      }
      // 用于上传后回显及往文件对象存值
      this.fileObj.push({
        file: data.file,
        uid: data.file.uid,
        name: data.file.name,
        status: 'done',
        type: 0
      });
    },
    /**
     * 文件大小
     */
    beforeUpload: function beforeUpload(file) {
      var $message = this.$message;
      var isLt1M = file.size / 1024 / 1024 < 500;
      if (!isLt1M) {
        $message.error('最大只能上传500MB');
      }
      return isLt1M;
    },
    /**
     * 文件删除
     */
    delFile: function delFile(data) {
      var fileObj = this.fileObj;
      if (1 === fileObj.length) {
        this.fileObj = [];
        this.formObject.detail.attach = [];
      } else {
        var evens = _.remove(fileObj, function (n) {
          if (n.fileid != data.fileid) {
            return n;
          }
        });
        this.fileObj = evens;
        this.formObject.detail.attach = evens;
      }
    },
    /**
     * 级联选择
     */
    onOrganAndJob: function onOrganAndJob(value, option) {
      var $set = this.$set,
        formObject = this.formObject;
      // 组织岗位赋值
      if (option) {
        $set(formObject.detail, 'organId', value[0]);
        $set(formObject.detail, 'postId', value[1]);
        $set(formObject.detail, 'typeId', option[0].typeId);
      } else {
        $set(formObject.detail, 'organId', '');
        $set(formObject.detail, 'postId', '');
        $set(formObject.detail, 'typeId', '');
      }
      this.formObject.detail.organPostId = value;
    },
    filterOption: function filterOption(inputValue, path) {
      return path.some(function (option) {
        return option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      }) || path.some(function (option) {
        return option.value.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      });
    },
    inputAmount: function inputAmount(value) {
      var number = Math.floor(value * 100) / 100;
      var ret = '';
      if (number !== '' && number != null && number !== '0') {
        var unit = '仟佰拾亿仟佰拾万仟佰拾元角分';
        var str = '';
        number += '00';
        var point = number.indexOf('.');
        if (point >= 0) {
          number = number.substring(0, point) + number.substr(point + 1, 2);
        }
        unit = unit.substr(unit.length - number.length);
        for (var i = 0; i < number.length; i++) {
          str += '零壹贰叁肆伍陆柒捌玖'.charAt(number.charAt(i)) + unit.charAt(i);
        }
        ret = str.replace(/零(仟|佰|拾|角)/g, '零').replace(/(零)+/g, '零').replace(/零(万|亿|元)/g, '$1').replace(/(亿)万|(拾)/g, '$1$2').replace(/^元零?|零分/g, '').replace(/元$/g, '元');
      }
      this.formObject.detail.totalAmountBig = ret;
    },
    /**
     * 计算逻辑
     */
    totalMoneyChange: function totalMoneyChange(value) {
      var formObject = this.formObject,
        inputAmount = this.inputAmount,
        toDecimal = this.toDecimal;
      var newTrafficmoney = 0;
      var newPeopleNum = 0;
      var newDayNum = 0;
      var newSubsidyStandard = 0;
      var newSubsidyMoney = 0;
      // 其他费用
      var newEntertainMoney = 0;
      var newFieldMoney = 0;
      var newFoodMoney = 0;
      var newInsuranceMoney = 0;
      var newWaterMoney = 0;
      // 合计
      var newMattertotalMoney = 0;
      _.forEach(formObject.detail.matterList, function (item) {
        newTrafficmoney += parseFloat(item.trafficmoney || 0);
        newPeopleNum += parseFloat(item.peoplenum || 0);
        newDayNum += parseFloat(item.daynum || 0);
        newSubsidyStandard += parseFloat(item.subsidystandard || 0);
        item.subsidymoney = parseFloat(item.peoplenum || 0) * parseFloat(item.daynum || 0) * parseFloat(item.subsidystandard) || 0;
        newSubsidyMoney += parseFloat(item.subsidymoney || 0);
        // 其他费用
        newEntertainMoney += parseFloat(item.servefee || 0);
        newFieldMoney += parseFloat(item.sitefee || 0);
        newFoodMoney += parseFloat(item.roomboardfee || 0);
        newInsuranceMoney += parseFloat(item.insurancefee || 0);
        newWaterMoney += parseFloat(item.waterfee || 0);
        // 计算合计
        if (item.trafficmoney || item.subsidymoney || item.servefee || item.sitefee || item.roomboardfee || item.insurancefee || item.waterfee) {
          item.mattertotal = _.sum([parseFloat(item.trafficmoney || 0), parseFloat(item.subsidymoney || 0), parseFloat(item.servefee || 0), parseFloat(item.sitefee || 0), parseFloat(item.roomboardfee || 0), parseFloat(item.insurancefee || 0), parseFloat(item.waterfee || 0)]);
          newMattertotalMoney += parseFloat(item.mattertotal || 0);
          item.mattertotal = toDecimal(item.mattertotal);
        } else {
          item.mattertotal = toDecimal(newMattertotalMoney);
        }
      });
      // 交通金额合计
      this.formObject.detail.trafficMoney = toDecimal(newTrafficmoney);
      // 出差人数合计
      this.formObject.detail.businessUser = newPeopleNum;
      // 出差天数合计
      this.formObject.detail.evectionDay = newDayNum;
      // 出差标准合计
      this.formObject.detail.evectionStandard = toDecimal(newSubsidyStandard);
      // 出差金额合计
      this.formObject.detail.evectionMoney = toDecimal(newSubsidyMoney);
      // 招待费合计
      this.formObject.detail.entertainMoney = toDecimal(newEntertainMoney);
      // 场地费合计
      this.formObject.detail.fieldMoney = toDecimal(newFieldMoney);
      // 食宿费合计
      this.formObject.detail.foodMoney = toDecimal(newFoodMoney);
      // 保险费合计
      this.formObject.detail.insuranceMoney = toDecimal(newInsuranceMoney);
      // 用水费合计
      this.formObject.detail.waterMoney = toDecimal(newWaterMoney);
      // 合计
      this.formObject.detail.mattertotalMoney = toDecimal(newMattertotalMoney);
      // 计算报销总额
      this.formObject.detail.totalAmount = _.sum([parseFloat(formObject.detail.mattertotalMoney)]);
      this.formObject.detail.totalAmount = toDecimal(this.formObject.detail.totalAmount);
      // 金额大写计算
      inputAmount(formObject.detail.totalAmount);
    },
    toDecimal: function toDecimal(num) {
      var f = parseFloat(num);
      if (isNaN(f)) {
        return false;
      }
      var f = Math.round(num * 100) / 100;
      var s = f.toString();
      var rs = s.indexOf('.');
      if (rs < 0) {
        rs = s.length;
        s += '.';
      }
      while (s.length <= rs + 2) {
        s += '0';
      }
      return s;
    },
    /**
     * 日期
     */
    disabledEnd: function disabledEnd(row) {
      // enddate startdate
      // console.log('=====>', row.startdate < startOfDay(row.startdate._d));

      // return row.startdate < startOfDay(row.startdate._d);
    },
    /**
     * 返回列表页
     */
    goBack: function goBack() {
      this.$router.push({
        path: '/reimburseRepairs/myReimburse/list'
      });
    }
  }
};